import React from "react";

import { JobAlerts, JobAlertsProps } from "@themuse/design-system";
import { triggerSnowplowImpressionEvent } from "@themuse/snowplow-js-client";

import { jobAlertsSubscribeRequest, JobAlertsSubmissionValues } from "utils/api";

import styles from "./JobAlert.module.scss";

interface JobAlertsModuleProps {
    jobCategory?: { value: string; label: string };
    jobLocations?: Array<{ value: string; label: string }>;
    jobLevel?: string;
    jobNormalizedTitle?: string;
}

const JobAlertsModule = (props: JobAlertsModuleProps) => {
    const {
        jobCategory, jobLocations, jobLevel, jobNormalizedTitle
    } = props;

    const onSuccessRefChange = (node: HTMLDivElement) => {
        if (node) {
            triggerSnowplowImpressionEvent(node);
        }
    };

    const handleFormSubmit = async (values) => {
        const apiData: JobAlertsSubmissionValues = {
            location: jobLocations?.[0]?.value,
            category: jobCategory?.value,
            level: jobLevel,
            keyword: jobNormalizedTitle,
            email: values?.email,
            newsletter: values?.newsletter
        };

        const optinSuccess = await jobAlertsSubscribeRequest(apiData);
        return optinSuccess;
    };

    const jobAlertsProps: JobAlertsProps = {
        handleFormSubmit,
        jobCategory: jobCategory?.label,
        jobLocations,
        successRef: onSuccessRefChange,
    };

    return <div className={styles.jobAlerts}><JobAlerts {...jobAlertsProps} /></div>;
};

export { JobAlertsModule };
